<template>
    <section class="inquiries-section">
        <div class="top-content page-content">
            <v-container class="inquiries-container pa-0">
                <v-row class="inquiries-wrapper mx-0">
                    <v-col cols="12" md="6" class="pa-0">
                        <div class="text-section">
                            <div class="text-group">
                                <img
                                    alt="logo"
                                    class="inquiries-logo-group"
                                    src="@/assets/icons/business-inquiries-logo.png"
                                />
                                <p class="text-title font-weight-bold">
                                    Connect with our team
                                </p>
                                <p class="text-subtitle">
                                    Nexon Game Card is available at 75,000+
                                    retailers and offered in 5 different
                                    currencies.<br />
                                    Find out how Nexon Game Card can help
                                    increase your business. <br />
                                    Fill out the form and we'll contact you
                                    soon.
                                </p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" class="pa-0">
                        <div class="card-section d-flex justify-center">
                            <div class="card-group">
                                <div class="fields-required-text">
                                    <span>* All fields are required.</span>
                                </div>
                                <v-card
                                    class="inquiries-card mx-auto"
                                    max-width="560"
                                    max-height="510"
                                >
                                    <v-card-text class="subject"
                                        >Subject</v-card-text
                                    >
                                    <v-form>
                                        <v-text-field
                                            v-model="subject"
                                            flat
                                            filled
                                            solo
                                            :error-messages="subjectErrors"
                                        ></v-text-field>
                                    </v-form>
                                    <v-card-text>Message</v-card-text>
                                    <v-form>
                                        <v-textarea
                                            v-model="description"
                                            flat
                                            filled
                                            solo
                                            rows="8"
                                            no-resize
                                            :error-messages="descriptionErrors"
                                        ></v-textarea>
                                    </v-form>
                                    <v-btn
                                        class="card-btn"
                                        rounded
                                        depressed
                                        width="266"
                                        height="60"
                                        :ripple="false"
                                        @click="submit"
                                        ><span
                                            id="contact-btn-contact-form-submit"
                                            >Submit</span
                                        >
                                    </v-btn>
                                </v-card>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
export default {
    name: 'contact',
    data() {
        return {
            subject: '',
            description: '',
        };
    },
    metaInfo() {
        return {
            titleTemplate: `%s | Business Inquiries`,
        };
    },
    validations: {
        subject: { required },
        description: { required },
    },
    computed: {
        subjectErrors() {
            if (this.$v.subject.$error) {
                return ['Subject is required.'];
            }
            return [];
        },
        descriptionErrors() {
            if (this.$v.description.$error) {
                return ['Description is required.'];
            }
            return [];
        },
    },
    methods: {
        submit() {
            this.$v.$touch();
            if (!this.$v.$error) {
                this.triggerContactForm();
            }
        },
        triggerContactForm() {
            window.location = `mailto:support@nexongamecard.com?subject=${encodeURIComponent(
                `(Business Inquiry) ${this.subject}`
            )}&body=${encodeURIComponent(this.description)}`;
        },
    },
};
</script>
<style lang="scss" scoped>
.inquiries-section {
    position: relative;
    background-image: url('../assets/connect-bg.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 100vh;
    padding-bottom: 60px;
    .inquiries-container {
        position: relative;
        top: 55px;
        .inquiries-wrapper {
            .text-section {
                margin: 0 auto 0 auto;
                max-width: 500px;
                min-height: 200px;
                .text-group {
                    color: #212843;
                    text-align: center;
                    .inquiries-logo-group {
                        display: none;
                    }
                    .text-title {
                        font-family: KlavikaNX-Regular, serif;
                        font-size: 42px;
                        letter-spacing: normal;
                        line-height: 1.2;
                        margin-bottom: 20px;
                        @include break('sm') {
                            margin-bottom: 23px;
                        }
                    }
                    .text-subtitle {
                        font-size: 14px;
                        @include break('md') {
                            font-size: 16px;
                            max-width: 557px;
                        }
                        line-height: 1.5;
                        color: #212843;
                        letter-spacing: normal;
                        margin-bottom: 60px;
                    }
                }
            }
            .card-section {
                margin: 0 auto;
                display: flex;
                justify-content: center;
                position: relative;
                overflow: hidden;
                padding: 0 30px;
                .card-group {
                    width: 100%;
                    .fields-required-text {
                        max-width: 560px;
                        margin: 0 auto;
                        text-align: right;
                        color: white;
                        font-size: 13px;
                        font-weight: 300;
                        margin-bottom: 10px;
                    }
                    .inquiries-card {
                        border-radius: 6px;
                        margin-bottom: 130px;
                        @include break('md') {
                            border-radius: 8px;
                            margin-bottom: 70px;
                        }
                        height: 510px;
                    }
                }
            }
        }
    }
}

.v-textarea,
.v-text-field {
    padding: 0 21px;
    @include break('sm') {
        padding: 0 40px;
    }
    .v-input__slot {
        border: solid 1px #e1e1e1;
    }
}
.v-card__text {
    font-size: 16px;
    font-weight: 500;
    color: #3f3f3f !important;
    padding-left: 21px;
    @include break('sm') {
        padding-left: 40px;
    }
    padding-top: 26px;
    &.subject {
        padding-top: 36px;
    }
}
.card-btn {
    position: static;
    display: block;
    margin: 0 auto;
    background-color: #2960e8 !important;
    color: #ffffff;
    &:hover {
        box-shadow: 0 8px 15px 0 #5776cf !important;
    }
    &:focus {
        background-color: #2960e8 !important;
        box-shadow: none !important;
    }
}

@include break('md') {
    .inquiries-section {
        padding-bottom: 0;
        .inquiries-container {
            max-width: 1120px;
            top: 0;
            height: calc(100vh - 60px);
            .inquiries-wrapper {
                height: 100%;
                .text-section {
                    max-width: 570px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding-right: 20px;
                    .text-group {
                        text-align: left;
                        .inquiries-logo-group {
                            height: 250px;
                            width: 250px;
                            margin: 0 auto 30px auto;
                            display: block;
                        }
                        .text-title {
                            font-size: 50px;
                            margin-bottom: 20px;
                        }
                        .text-subtitle {
                            font-size: 16px;
                        }
                    }
                }
                .card-section {
                    max-width: 570px;
                    height: 100%;
                    align-items: center;
                }
            }
        }
    }
}
@include break('lg') {
    .inquiries-section {
        .inquiries-container {
            max-width: 1160px;
            .inquiries-wrapper {
                .text-section {
                    padding-right: 40px;
                    .text-group {
                        text-align: center;
                        .inquiries-logo-group {
                            margin: 0 auto 30px auto;
                        }
                        .text-title {
                            font-size: 50px;
                            margin-bottom: 20px;
                        }
                        .text-subtitle {
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
}

@include break('xl') {
    .inquiries-section .inquiries-container {
        max-width: 1270px;
    }
}
</style>

<style lang="scss">
.inquiries-section {
    .v-text-field__details {
        margin: 0 0 -4px 0;
        .error--text {
            font-size: 11px !important;
            color: #e92852 !important;
        }
    }
    .v-text-field--filled.v-text-field--single-line input {
        margin-top: 0;
    }
    .v-text-field--filled input {
        margin-top: 0;
    }
    .v-textarea,
    .v-text-field {
        .v-input__slot {
            border: solid 1px #e1e1e1;
        }
    }
}
</style>
